import { z } from 'zod'

const RepoStats = z.object({
  pulls: z.number(),
  size: z.number()
})

export const RegistryRepoList = z.object({
  repositories: z.array(z.string()).default([]),
  stats: z.record(z.string(), RepoStats).optional()
})
export type RegistryRepoList = z.infer<typeof RegistryRepoList>

export const RegistryTag = z.object({
  tag: z.string(),
  digest: z.string().optional(),
  size: z.number().optional(),
  last_updated: z.string().optional()
})
export type RegistryTag = z.infer<typeof RegistryTag>

export const RegistryTagList = z.object({
  tags: z.array(RegistryTag).default([])
})
export type RegistryTagList = z.infer<typeof RegistryTagList>
